import state from './dashboard.state'
import mutations from './dashboard.mutations'
import actions from './dashboard.actions'

export default {
  state,
  mutations,
  actions
}
